<template>
    <div class="course_list flex FlexWrap FlexBetween">
        <div class="flex course_one flexcolumn FlexBetween cursor_pointer" v-for="(item, index) in hotCourseList"
            :key="index" @click="goCourseDetail(item)">
            <div class="course_one_top">
                <el-image class="course_one_img" :src="imgPath(item.courseCoverImg)"></el-image>
            </div>
            <div class="flex course_one_bottom flexcolumn FlexEvenly">
                <div class="course_one_title toverflows toverflow2">{{ item.courseName }}</div>
                <div class="course_one_institution flex FlexBetween">
                    <div class="course_one_institution_left flex Flexalign">
                        <div class="institutionName toverflow">{{ item.shopName }}</div>
                    </div>
                    <div class="course_num">{{ item.chapterCountResult?.chapterNum }}课时</div>
                </div>
                <div class="course_rate">
                    <el-rate v-model="item.rate" disabled show-score text-color="#666666" score-template="{value}分" />
                </div>
                <div class="flex FlexBetween Flexalign course_info">
                    <div class="course_online">{{ item.courseExtra.userNum }}人学习</div>
                    <!-- <div class="course_price">
                        <span class="course_price_unit">￥</span>{{ (item.saleMethod == 2) ? item.coursePrice : 0 }}
                    </div> -->
                    <div class="course_price" v-if="item.saleMethod == 2">
                        <span class="course_price_unit">￥</span>{{ item.saleMethod == 2 ? item.coursePrice : 0 }}
                    </div>
                    <div class="course_price course_free" v-else>免费</div>
                </div>
            </div>
        </div>
        <div v-if="hotCourseList.length % 4 != 0" class="flex">
            <div class="empty_course_one course_one" v-for="item in 4 - (hotCourseList.length % 4)" :key="item">
                <div class="course_one_top">
                    <el-image class="course_one_img" style="border-radius: 20px"
                        :src="imgPath('course_img.png')"></el-image>
                    <div class="course_one_type">热销</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5CourseList",
    props: {
        courseDetail: {},
    },
    computed: {
        ...mapState({
            selectCourseType: (state) => state.user.selectCourseType,
        }),
    },
    watch: {
        courseDetail: {
            handler(value) {
                if (!value) return;
                if (value.shopId) {
                    this.selectedInfo.shopId = this.courseDetail.shopId;
                    this.getCourseList();
                }
            },
            immediate: true,
            deep: true
        },
        selectCourseType: {
            handler(value) {
                this.selectedInfo.typeId = value;
                this.getCourseList();
            },
            deep: true,
            immediate: true
        },
    },

    data() {
        return {
            hotCourseList: [],
            selectedInfo: {
                shopId: "", // 商家Id
                courseName: "", // 课程名
                stageId: "", // 所属学段ID
                gradeId: "", // 所属年级ID
                subjectId: "", // 所属学科ID
                termId: "", // 所属学期ID
                publisherId: "", // 所属版本ID
                courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
                textbookId: "", // 所属教材ID
                courseDifficulty: "", // 课程难度
                learningStyle: "", // 学习方式（1=不限、2=闯关学习）
                saleMethod: "", // 售卖方式（1=免费，2=付费）
                pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
                page: 1, // 页码
                pageSize: 4, // 单页数量
                orderByColumn: 'hot_sales', // 猜你想学
                typeId:'',  // 课程类型
            },
        };
    },

    mounted() {
        this.getCourseList();
    },

    methods: {
        // 获取课程列表
        getCourseList() {
            this.$Api.course
                .getCourseList(this.selectedInfo)
                .then((res) => {
                    this.hotCourseList = res.data.data.list;
                    this.hotCourseList.forEach((item) => {
                        item.rate = this.$Tools.scoreToStar(item.courseExtra.appraiseScore);
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 详情
        goCourseDetail(info) {
            this.$Jump.href("/courseDetail", { courseId: info.courseId }, true);
        },
    },
};
</script>
<style lang="scss" scoped>
.course_list {
    width: 100%;
    padding: 0;

    .course_one {
        border-radius: 20px;
        border: 1px solid #e3e3e3;
        box-sizing: border-box;
        height: 250px;
        margin-top: 12px;
        // padding: 11px;

        .course_one_top {
            position: relative;

            .course_one_img {
                width: 188px;
                height: 110px;
                border-radius: 10px 10px 0 0;
            }

            .course_one_type {
                position: absolute;
                right: 0;
                top: 0;
                width: 54px;
                height: 21px;
                background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
                border-radius: 0px 20px 0px 20px;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
            }
        }

        .course_one_bottom {
            height: 132px;
            padding: 0 11px 11px;
            box-sizing: border-box;
        }

        .course_one_title {
            width: 164px;
            // padding: 0 10px;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            // margin: 5px 0;
            height: 42px;
            line-height: 21px;
        }

        .course_one_institution {

            // padding: 0 10px;

            .course_one_institution_left {
                .institutionName {
                    max-width: 100px;
                    color: rgba(102, 102, 102, 1);
                    // margin-left: 6px;
                }
            }

            .course_num {
                color: rgba(102, 102, 102, 1);
            }
        }

        .course_rate {

            // padding: 0 10px;
            height: 20px;
            font-size: 12px;
            // margin: 5px 0 5px;

            :deep(.el-rate .el-rate__icon) {
                margin-right: 0;
                height: 20px;
            }

            :deep(.el-rate) {
                height: auto;
            }
        }

        .course_info {

            // padding: 0 10px;

            .course_online {
                font-size: 12px;
                color: #999999;
            }

            .course_price {
                color: #ff6619;
                font-size: 18px;
                font-weight: 600;

                .course_price_unit {
                    font-size: 16px;
                    font-weight: 400;
                }
            }

            .course_free {
                font-size: 16px;
                font-weight: 400;
            }
        }

        .empty_box {
            width: 100%;
            height: 15px;
        }
    }

    .empty_course_one {
        opacity: 0;
    }
}
</style>